function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import styled from '@emotion/styled';
import { compose } from 'styled-system';
import { NeoSystem, NeoSystemProps } from "../../system";
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

var sx = function sx(props) {
  return css(props.sx)(props.theme);
};

var _getBaseStyle = function _getBaseStyle(props) {
  return props._getBaseStyle && css(props._getBaseStyle(props))(props.theme);
};

var heightStyle = {
  fluid: {
    height: '100%'
  },
  auto: {
    height: 'auto'
  }
};

var baseStyle = function baseStyle(props) {
  return heightStyle[props.height];
};

var StyledBox = styled('div', {
  shouldForwardProp: shouldForwardProp
})(baseStyle, _getBaseStyle, sx, compose(NeoSystem.COMMON, NeoSystem.LAYOUT, NeoSystem.BORDER));
var Box = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledBox, _extends({}, props, {
    ref: ref
  }));
});
Box.displayName = 'Box';
export { Box };
export default Box;